/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RequestAuthCode_requestAuthCode_RequestAuthCode = { readonly __typename: 'RequestAuthCode', readonly email: string | null };

export type RequestAuthCode_Mutation = { readonly __typename: 'Mutation', readonly requestAuthCode: RequestAuthCode_requestAuthCode_RequestAuthCode | null };


export type RequestAuthCodeVariables = _Types.Exact<{
  email: _Types.Scalars['String']['input'];
}>;


export type RequestAuthCode = RequestAuthCode_Mutation;


export const RequestAuthCodeDocument = gql`
    mutation RequestAuthCode($email: String!) {
  requestAuthCode(email: $email) {
    email
  }
}
    `;
export type RequestAuthCodeMutationFn = Apollo.MutationFunction<RequestAuthCode, RequestAuthCodeVariables>;

/**
 * __useRequestAuthCode__
 *
 * To run a mutation, you first call `useRequestAuthCode` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestAuthCode` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestAuthCode, { data, loading, error }] = useRequestAuthCode({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRequestAuthCode(baseOptions?: Apollo.MutationHookOptions<RequestAuthCode, RequestAuthCodeVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestAuthCode, RequestAuthCodeVariables>(RequestAuthCodeDocument, options);
      }
export type RequestAuthCodeHookResult = ReturnType<typeof useRequestAuthCode>;
export type RequestAuthCodeMutationResult = Apollo.MutationResult<RequestAuthCode>;
export type RequestAuthCodeMutationOptions = Apollo.BaseMutationOptions<RequestAuthCode, RequestAuthCodeVariables>;